import React from "react";
import { Navigate, Outlet}  from 'react-router-dom';
import { getObjectValue } from '@utility/utills';
import { safeJsonParse } from "./utility/helperFunction";

const privateRoute = () => {
    const userInfo = getObjectValue(() => safeJsonParse(window.sessionStorage.getItem('userInfo'), false));
    return userInfo ? (
        <Outlet/>
    ) : (
            <Navigate to="/checkIn" />
    )
}
export default privateRoute;